<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-content">
        <div class="navbar-brand">
          <img src="../assets/logo.png" alt="弋沐" class="logo-image">
          <span>弋沐</span>
        </div>
        <div class="navbar-menu" :class="{ active: isMenuOpen }">
          <router-link to="/home" class="navbar-item" :class="{ active: $route.path === '/home' }">
            <font-awesome-icon icon="fa-solid fa-house" />
            <span>首页</span>
          </router-link>
          <router-link to="/workflow" class="navbar-item" :class="{ active: $route.path === '/workflow' }">
            <font-awesome-icon icon="fa-solid fa-chart-diagram" />
            <span>工作流</span>
          </router-link>
          <router-link to="/prompt" class="navbar-item" :class="{ active: $route.path === '/prompt' }">
            <font-awesome-icon icon="fa-solid fa-code" />
            <span>提示词</span>
          </router-link>
          <router-link to="/learning" class="navbar-item" :class="{ active: $route.path === '/learning' }">
            <font-awesome-icon icon="fa-solid fa-book-open" />
            <span>AI学习</span>
          </router-link>
          <router-link to="/feedback" class="navbar-item" :class="{ active: $route.path === '/feedback' }">
            <font-awesome-icon icon="fa-solid fa-envelope" />
            <span>联系我们</span>
          </router-link>
          <router-link to="/login" class="navbar-item btn-login">
            <font-awesome-icon icon="fa-solid fa-right-to-bracket" />
            <span>登录</span>
          </router-link>
        </div>
      </div>
      <div class="navbar-toggle" @click="toggleMenu">
          <font-awesome-icon icon="fa-solid fa-bars" />
        </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

/* 导航栏 */
.navbar {
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  padding: 16px 0;
}

.navbar .container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: 700;
  color: #667eea;
  text-decoration: none;
}

.logo-image {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  object-fit: contain;
}

.navbar-brand i {
  margin-right: 12px;
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 40px;
  flex: 1;
  justify-content: center;
}

.navbar-item {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 18px;
  transition: all 0.3s ease;
  padding: 10px 16px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
}

.navbar-item:hover,
.navbar-item.active {
  color: #667eea;
  font-weight: 600;
  background-color: rgba(102, 126, 234, 0.05);
}

/* 激活状态 */
.navbar-item.active {
  color: #667eea;
  font-weight: 600;
  position: relative;
}

.navbar-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 3px;
  background-color: #667eea;
  border-radius: 3px;
}

.dropdown-item.active {
  color: #667eea;
  font-weight: 600;
}

.navbar-dropdown.active .dropdown-toggle {
  color: #667eea;
  font-weight: 600;
}

/* 登录注册按钮 */
.btn-login {
  background-color: transparent;
  border: 2px solid #667eea;
  color: #667eea;
  padding: 10px 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 18px;
}

.btn-login:hover {
  background-color: #667eea;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* 下拉菜单 */
.navbar-dropdown {
  position: relative;
}

.dropdown-toggle {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dropdown-toggle::after {
  content: '▼';
  font-size: 10px;
  margin-left: 8px;
  transition: transform 0.3s ease;
  color: #666;
}

.navbar-dropdown:hover .dropdown-toggle::after {
  transform: rotate(180deg);
  color: #667eea;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 12px 0;
  min-width: 160px;
  z-index: 1001;
  margin-top: 8px;
  display: none;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.navbar-dropdown:hover .dropdown-menu {
  display: block;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.dropdown-item {
  display: block;
  padding: 10px 20px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 14px;
}

.dropdown-item:hover {
  background-color: rgba(102, 126, 234, 0.05);
  color: #667eea;
  padding-left: 24px;
}

.navbar-toggle {
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  transition: color 0.3s ease;
  padding: 8px;
  border-radius: 4px;
}

.navbar-toggle:hover {
  color: #667eea;
  background-color: rgba(102, 126, 234, 0.05);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .navbar-menu {
    gap: 20px;
  }

  .navbar-item {
    font-size: 16px;
    padding: 8px 12px;
  }

  .btn-login {
    padding: 8px 16px;
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 12px 0;
  }

  .navbar-content {
    flex-direction: row;
    justify-content: space-between;
  }

  .navbar-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
    gap: 10px;
    margin-top: 12px;
    border-radius: 0 0 8px 8px;
  }

  .navbar-menu.active {
    display: flex;
    animation: slideDown 0.3s ease;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .navbar-dropdown {
    position: relative;
  }

  .dropdown-menu {
    position: static;
    box-shadow: none;
    margin-top: 10px;
    padding-left: 20px;
    border: none;
    border-radius: 0;
  }

  .navbar-toggle {
    display: block;
  }

  .navbar-item {
    width: 100%;
    max-width: 200px;
    justify-content: center;
    padding: 12px 20px;
  }

  .btn-login {
    width: 100%;
    max-width: 200px;
    text-align: center;
    margin-top: 10px;
  }
}
</style>